import { put } from "@redux-saga/core/effects";
import { ContractApi } from "../../../generated/api/apis/ContractApi";
import { getAPIConfig } from "../../../util/api-config";
import { handleError } from "../../../util/errorHandler";
import store from "../../configureStore";
import {
  setAvailableCarePrincipalsForContract,
  // COMFACT - KOMMER ATT TAS BORT 
  // setContract,
  // setSelectedContract,
  // setSignedContract,
  // setSignInstance,
} from "../../reducers/contractReducer";

function setUpClient() {
  return new ContractApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

// COMFACT - KOMMER ATT TAS BORT 
// export function* handleGetContract(action: any): any {
//   try {
//     const contractClient = setUpClient();
//     const response = yield contractClient.getContract(action.contractId);
//     const contract = URL.createObjectURL(response);
//     yield put(setContract(contract));
//   } catch (error) {
//    yield handleError(error);
//   }
// }
// 
// export function* handleGetSignedContract(action: any): any {
//   try {
//     const contractClient = setUpClient();
//     const response = yield contractClient.getSignedContract(
//       action.params.carePrincipalId,
//       action.params.careProviderId
//     );
//     const contract = URL.createObjectURL(response);
//     yield put(setSignedContract(contract));
//   } catch (error) {
//     yield handleError(error);
//   }
// }
//
// export function* handleSignContract(action: any): any {
//   try {
//     const contractClient = setUpClient();
//     const response = yield contractClient.signContract(
//       action.params.carePrincipalId,
//       action.params.careProviderId,
//       action.params.contractId
//     );
//     yield put(setSignInstance(response));
//     yield put(push("/signContractForm"));
//   } catch (error) {
//     yield handleError(error);
//   }
// }

export function* handleGetAvailableCarePrincipals(action: any): any {
  try {
    const contractClient = setUpClient();
    const response = yield contractClient.getCarePrincipalsEligibleForContract(
      action.careProviderId
    );
    yield put(setAvailableCarePrincipalsForContract(response));
  } catch (error) {
    yield handleError(error);
  }
}

// COMFACT - KOMMER ATT TAS BORT 
// export function* handleCreateContract(action: any): any {
//   try {
//     const contractClient = setUpClient();

//     const response = yield contractClient.createContract(
//       true,
//       action.signInformation
//     );
//     yield put(setSelectedContract(response));
//   } catch (error) {
//     yield handleError(error);
//   }
// }
